'use client';
import { useEventBus } from '@/libs/hooks/use-event-bus';
import { FeedDto } from '@/libs/api/feed';

// Event name for feed like status changes (must match the one in useFeedLike)
const FEED_LIKE_EVENT = 'feed-like-status-change';

// Event payload type
interface FeedLikeEvent {
  feedId: string;
  isLiked: boolean;
  likeCount?: number;
}

/**
 * Hook for listening to feed like events and updating feed data
 * @param setFeeds Function to edit feeds state
 */
export const useFeedLikeEvent = (
  setFeeds: React.Dispatch<React.SetStateAction<FeedDto[]>>
) => {
  // Listen for feed like events
  useEventBus<FeedLikeEvent>(FEED_LIKE_EVENT, (data) => {
    setFeeds(prevFeeds => {
      return prevFeeds.map(feed => {
        // Only edit the feed that matches the event feedId
        if (feed.sid === data.feedId) {
          // Calculate the new like count
          let newLikeCount = feed.likeCount || 0;
          if (data.isLiked && !feed.isLike) {
            // If liked and wasn't liked before, increment
            newLikeCount += 1;
          } else if (!data.isLiked && feed.isLike) {
            // If unliked and was liked before, decrement
            newLikeCount = Math.max(0, newLikeCount - 1);
          }
          
          // Return updated feed with new like status and count
          return {
            ...feed,
            isLike: data.isLiked,
            likeCount: newLikeCount
          };
        }
        return feed;
      });
    });
  });
};